import ReactRouterPropTypes from 'react-router-prop-types';
import { withRouter } from 'react-router-dom';

import ErrorPage from '../components/ErrorPage';

const ErrorPageContainer = ({ history }) => (
  <ErrorPage
    title=" Oops, we can’t seem to find the page that you are looking for."
    illustrationUrl="https://images.snaphunt.com/assets/illustrations/404-illustration.svg"
    description="The page you are looking for might have been removed, had its name changed, or is temporarily unavailable."
    buttonProps={{
      label: 'Back to home',
      onClick: () => history.push('/'),
    }}
  />
);

ErrorPageContainer.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
};

export default withRouter(ErrorPageContainer);
